import { Stack } from "@mantine/core";
import {
  IconDeviceIpadQuestion,
  IconFileDescription,
  IconFileSymlink,
  IconHome2,
  IconQuestionMark,
  IconReportAnalytics,
  IconUserPlus
} from "@tabler/icons-react";
import { NavLink } from "react-router-dom";
import useGetColaboradorById from "@/modules/colaboradores/hooks/useGetColaboradorById";
import useUserStore from "@/modules/users/store";
import { getCurrentUser } from "@/services/auth";
import { dataAutorizacoes } from "@/src/routes/empresa-page/EmpresaPage";
import { ID_QUESTIONARIO_INOVACAO, ID_CADASTROS_EMBAIXADORES } from "@/utils/constants";
import NavLinkMenu from "./NavLinkMenu";

// eslint-disable-next-line complexity
const AppDiagnosticoMenu = ({ toggleMobile }: { toggleMobile: () => void }) => {
  const activeEmpresaId = useUserStore((store) => store.activeEmpresa);
  const projeto = useUserStore((state) => state.activeProjeto);
  const activeAutorizacao = useUserStore((store) => store.autorizacoes);
  const uid = getCurrentUser()?.uid;
  const { data: userColaborador } = useGetColaboradorById(activeEmpresaId?.id || "", uid || "");
  const getAuthorization = (tipoAutorizacao: string) =>
    formatAutorizacoes?.find((item) => item.tipoAutorizacao === tipoAutorizacao);
  const autorizacao = dataAutorizacoes.find((item) => item.label === userColaborador?.role);
  const formatAutorizacoes = activeAutorizacao?.filter((item) => item.tipo === autorizacao?.value);

  if (activeEmpresaId && activeEmpresaId?.status === "INATIVO") {
    return <></>;
  }
  // prettier-ignore
  return (
    <Stack mx="md" mt="lg" gap="xs">
      <NavLinkMenu
        label="Início"
        leftSection={<IconHome2 size="1.2rem" stroke={1.5} />}
        component={NavLink}
        onClick={toggleMobile}
        to="/diagnostico"
      />
      {projeto && getAuthorization(ID_QUESTIONARIO_INOVACAO)?.leitura ? (
        <NavLinkMenu
          label="Questionário de Inovação"
          leftSection={<IconDeviceIpadQuestion size="1.2rem" stroke={1.5} />}
          component={NavLink}
          to="/questionarioDeInovacao"
          onClick={toggleMobile}
        />
      ) : null}
      {getAuthorization("29")?.leitura ? (
        <NavLinkMenu
          label="Responder questionário"
          leftSection={<IconFileSymlink size="1.2rem" stroke={1.5} />}
          component={NavLink}
          to="/listaResponderQuestionario/0"
          onClick={toggleMobile}
        />
      ) : null}
      {getAuthorization("30")?.leitura ? (
        <NavLinkMenu
          label="Convidar Colaboradores"
          leftSection={<IconUserPlus size="1.2rem" stroke={1.5} />}
          component={NavLink}
          onClick={toggleMobile}
          to="/convidarColaboradores"
        />
      ) : null}
      {getAuthorization("25")?.leitura ? (
        <NavLinkMenu
          label="Gerenciar Evidências"
          leftSection={<IconFileDescription size="1.2rem" stroke={1.5} />}
          component={NavLink}
          to="/gerenciarEvidencias"
        />
      ) : null}
      {getAuthorization("34")?.leitura ? (
        <NavLinkMenu
          label="Votação Prêmio Empresa Inspiradora"
          leftSection={<IconFileDescription size="1.2rem" stroke={1.5} />}
          component={NavLink}
          to="/resultadoVotacaoEmpresaInspiradora"
        />
      ) : null}
      {getAuthorization("31")?.leitura ? (
        <NavLinkMenu
          label="Relatórios"
          leftSection={<IconReportAnalytics size="1.2rem" stroke={1.5} />}
          component={NavLink}
          onClick={toggleMobile}
          to="/relatorios"
        />
      ) : null}
      {(getAuthorization("13")?.leitura ||
        getAuthorization("5")?.leitura ||
        getAuthorization("8")?.leitura ||
        getAuthorization("6")?.leitura ||
        getAuthorization("7")?.leitura ||
        getAuthorization("28")?.leitura ||
        getAuthorization(ID_CADASTROS_EMBAIXADORES)?.leitura)
        && (
          <NavLinkMenu label="Cadastros" leftSection={<IconQuestionMark size="1.2rem" stroke={1.5} />}>
            {getAuthorization("13")?.leitura && (
              <NavLinkMenu label="Projetos" component={NavLink} onClick={toggleMobile} to="/projetos" />
            )}
            {getAuthorization(ID_CADASTROS_EMBAIXADORES)?.leitura && (
              <NavLinkMenu label="Embaixadores" component={NavLink} onClick={toggleMobile} to="/embaixadores" />
            )}
            {getAuthorization("5")?.leitura && (
              <NavLinkMenu label="Questionários" component={NavLink} onClick={toggleMobile} to="/questionarios" />
            )}
            {getAuthorization("8")?.leitura && (
              <NavLinkMenu
                label="Tipo de Respostas"
                component={NavLink}
                onClick={toggleMobile}
                to="/tipos-de-respostas"
              />
            )}
            {projeto && getAuthorization("6")?.leitura && (
              <NavLinkMenu label="Grupos de Perguntas" component={NavLink} onClick={toggleMobile} to="/gruposDiagnostico" />
            )}
            {projeto && getAuthorization("7")?.leitura && (
              <NavLinkMenu label="Perguntas" component={NavLink} onClick={toggleMobile} to="/perguntas" />
            )}
            {projeto && getAuthorization("28")?.leitura && (
              <NavLinkMenu label="Regiões" component={NavLink} onClick={toggleMobile} to="/regioes" />
            )}
          </NavLinkMenu>
        )}
    </Stack>
  );
};

export default AppDiagnosticoMenu;
